import { login, logout, getInfo } from '@/api/login'
import { getRouters } from "@/api/menu"
import { orgList } from '@/api/global/organization'
import { getToken, setToken, removeToken } from '@/utils/auth'
// import {noticeMeCount} from "@/api/system/notice"

const user = {
  state: {
    token: getToken(),
    id: '', // 用户id
    name: '', // 用户名
    nickname: '', // 用户昵称
    avatar: '', // 用户头像
    roles: [], // 用户角色
    permissions: [], // 用户全新啊
    routers: [], // 路由
    orgList: [], // 机构组
    minRoleType: '',
    noticeMeCount: 0 // 我的通知未读数量
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_ID: (state, id) => {
      state.id = id
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_NICKNAME: (state, nickname) => {
      state.nickname = nickname
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
    SET_ROUTERS: (state, routers) => {
      state.routers = routers
    },
    SET_ORG_LIST: (state, orgList) => {
      state.orgList = orgList
    },
    SET_MIN_ROLE_TYPE: (state, roleType) => {
      state.minRoleType = roleType
    },
    SET_NOTICE_ME_COUNT: (state, noticeMeCount) => {
      state.noticeMeCount = noticeMeCount
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      const password = userInfo.password
      const code = userInfo.code
      const uuid = userInfo.uuid
      return new Promise((resolve, reject) => {
        login(username, password, code, uuid).then(res => {
          setToken(res.token)
          commit('SET_TOKEN', res.token)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getInfo().then(res => {
          const user = res.user
          if(!res.user) {
            reject(null)
            return
          }
          const avatar = (!user || user.avatar == "" || user.avatar == null) ? require("@/assets/logo.png") : process.env.VUE_APP_BASE_API + user.avatar
          if (res.roles && res.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', res.roles)
            commit('SET_PERMISSIONS', res.permissions)
          } else {
            commit('SET_ROLES', ['ROLE_DEFAULT'])
          }
          commit('SET_ID', user.userId)
          commit('SET_NAME', user.userName)
          commit('SET_NICKNAME', user.nickName)
          commit('SET_AVATAR', avatar)
          commit('SET_MIN_ROLE_TYPE', user.minRoleType)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    GetOrgList({ commit }) {
      return new Promise((resolve, reject) => {
        orgList().then(res=> {
          commit('SET_ORG_LIST', res.data)
          resolve('ok')
        }).catch(err => {
          reject(err)
        })
      })
    },

    // 获取用户菜单
    GetRouterMenus({ commit }) {
      return new Promise((resolve, reject) => {
        getRouters().then((res) => {
          if(res.data && res.data.length > 0) {
            commit('SET_ROUTERS', res.data)
          }
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },

    // 退出系统
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_PERMISSIONS', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    },
    // 获取我的通知未读数
    GetNoticeMeCount({ commit }) {
      commit('SET_NOTICE_ME_COUNT', 0)
      // console.log(commit)
      // return new Promise((resolve, reject) => {
      //   noticeMeCount().then(res=> {
      //     commit('SET_NOTICE_ME_COUNT', res.data)
      //     resolve('ok')
      //   }).catch(err => {
      //     reject(err)
      //   })
      // })
    }
  }
}

export default user
